import { render, staticRenderFns } from "./dalogMediaList.vue?vue&type=template&id=1f33a3f2&scoped=true&"
import script from "./dalogMediaList.vue?vue&type=script&lang=js&"
export * from "./dalogMediaList.vue?vue&type=script&lang=js&"
import style0 from "./dalogMediaList.vue?vue&type=style&index=0&id=1f33a3f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f33a3f2",
  null
  
)

export default component.exports